import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=64270a9b&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=64270a9b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64270a9b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64270a9b')) {
      api.createRecord('64270a9b', component.options)
    } else {
      api.reload('64270a9b', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=64270a9b&scoped=true&", function () {
      api.rerender('64270a9b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-221B2NMxSpiin/JS/teamMember.vue"
export default component.exports